<script setup>
import {defineProps, ref} from 'vue'
import {useSystem} from "../../store/system";
import {useRouter} from "vue-router";
const props = defineProps({
  onlyShowBottom: {
    type: Boolean,
    required: true,
    default: false
  }
})
const systemStore = useSystem()
const router = useRouter()

let companyAddress = ref('')
setTimeout(() => {
  companyAddress.value = systemStore.getFrontModuleContent(19)?.json_data[0].desc
}, 3500)

const jumpLink = (url) => {
  window.open(url, '_blank');
}
</script>

<template>
  <!-- footer -->
  <div class="footer" :class="props.onlyShowBottom ? '!tw-pt-[0px]' : ''">
    <div class="container">
      <div class="row tw-pb-[4rem]" v-if="!props.onlyShowBottom">

<!--        <div class="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-4">-->
<!--          &lt;!&ndash; footer logo &ndash;&gt;-->
<!--          <div class="footer__logo xs:tw-text-center md:tw-text-left">-->
<!--            <el-image :src="systemStore.getWebsite.website_logo" fit="cover" />-->
<!--          </div>-->
<!--          &lt;!&ndash; end footer logo &ndash;&gt;-->

<!--          <div class="xs:tw-mt-4 tw-cursor-pointer tw-text-left">-->
<!--            <i v-if="systemStore.getWebsite.youtube_link" @click="jumpLink(systemStore.getWebsite.youtube_link)" class="ti ti-brand-youtube !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--            <i v-if="systemStore.getWebsite.twitter_link" @click="jumpLink(systemStore.getWebsite.twitter_link)" class="ti ti-brand-x !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--            <i v-if="systemStore.getWebsite.telegram_link" @click="jumpLink(systemStore.getWebsite.telegram_link)" class="ti ti-brand-telegram !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--          </div>-->

<!--          &lt;!&ndash; footer tagline &ndash;&gt;-->
<!--          <p class="footer__tagline tw-pb-[2rem]">{{companyAddress}}</p>-->
<!--          &lt;!&ndash; end footer tagline &ndash;&gt;-->

<!--        </div>-->

        <div class="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-4">
          <h6 class="footer__title">Community</h6>
          <div class="footer__nav">
            <div class="xs:tw-mt-4 tw-cursor-pointer tw-text-left">
              <i v-if="systemStore.getWebsite.youtube_link" @click="jumpLink(systemStore.getWebsite.youtube_link)" class="ti ti-brand-youtube !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>
              <i v-if="systemStore.getWebsite.twitter_link" @click="jumpLink(systemStore.getWebsite.twitter_link)" class="ti ti-brand-x !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>
              <i v-if="systemStore.getWebsite.telegram_link" @click="jumpLink(systemStore.getWebsite.telegram_link)" class="ti ti-brand-telegram !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>
            </div>
            <div class="footer__tagline">{{companyAddress}}</div>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3 col-xl-2">
          <h6 class="footer__title">Services</h6>
          <div class="footer__nav">
            <a href="Javascript:;" @click="router.push({path:'/Products'})">Mining Plans</a>
            <a href="Javascript:;" @click="router.push({path:'/Contest'})">Earn Free Bitcoin</a>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3 col-xl-2">
          <h6 class="footer__title">About</h6>
          <div class="footer__nav">
            <a href="Javascript:;" @click="router.push({path:'/About'})">Company</a>
            <a href="Javascript:;" @click="router.push({path:'/Blog'})">Crypto News</a>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3 col-xl-2">
          <h6 class="footer__title">Support</h6>
          <div class="footer__nav">
            <a href="Javascript:;" @click="router.push({path:'/Faq'})">FAQ</a>
            <a href="Javascript:;" @click="router.push({path:'/About'})">What is Cloud Mining</a>
          </div>
        </div>

        <div class="col-6 col-md-4 col-lg-3 col-xl-2">
          <h6 class="footer__title">Legal</h6>
          <div class="footer__nav">
            <a href="Javascript:;" @click="router.push({path:'/TermsOfUse'})">Terms of Use</a>
            <a href="Javascript:;" @click="router.push({path:'/Privacy'})">AML Policy</a>
          </div>
        </div>

        <!-- end navigation -->
      </div>

      <div class="row">
        <div class="col-12">
          <div class="footer__content mt-0" :class="props.onlyShowBottom ? '!tw-mt-[0px] tw-h-[70px]' : ''">

            <!-- footer copyright -->
            <small class="footer__copyright">{{systemStore.getWebsite.copyright_notice}}</small>
            <!-- end footer copyright -->

<!--            <div class="xs:tw-mt-4 tw-cursor-pointer tw-order-2">-->
<!--              <i v-if="systemStore.getWebsite.youtube_link" @click="jumpLink(systemStore.getWebsite.youtube_link)" class="ti ti-brand-youtube !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--              <i v-if="systemStore.getWebsite.twitter_link" @click="jumpLink(systemStore.getWebsite.twitter_link)" class="ti ti-brand-x !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--              <i v-if="systemStore.getWebsite.telegram_link" @click="jumpLink(systemStore.getWebsite.telegram_link)" class="ti ti-brand-telegram !tw-text-[1.5rem] tw-text-[#b0b0b0] first:!tw-ml-0 tw-ml-4"></i>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- design elements -->
    <span class="screw screw--footer screw--footer-bl"></span>
    <span class="screw screw--footer screw--footer-br"></span>
    <span class="screw screw--footer screw--footer-tr"></span>
    <span class="screw screw--footer screw--footer-tl"></span>
  </div>
  <!-- end footer -->
</template>

<style lang="scss">
.footer__logo img{
  height: 80px;
}
</style>
